import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getCuratedRegistrationList, sendWelcomeEmailCamp } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class ViewPaymentCamp extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              paymentlist: [],
              openedAdd:false
        };
        this.camp_id = this.props.match.params.camp_id ? this.props.match.params.camp_id : '';
        this.getCuratedPaymentCampList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_item', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }
 
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      
    };  
 

    getCuratedPaymentCampList = () => {

        getCuratedRegistrationList(this.camp_id).then((res) => {
            if (res.status == 1) {
                this.setState({
                   paymentlist: res.data,
                });
                //this.datatabledata(res.data);
            } else {
                this.setState({
                    paymentlist: [],
                });
            }
        });
    }


    handleClick= (reg_id, camp_id) => {  

        let ins = JSON.stringify({
            reg_id: reg_id,
            camp_id: camp_id
        });

        sendWelcomeEmailCamp(ins).then((res) => {
          let toastr = '';
            if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('success', 'Mail is sent successfully', {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
          
            } else {
                toastr = res.message; //warning
                toastr('Error', toastr, {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
            }

         });


    }

    render() {

        const { paymentlist } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Curated Camps- Payments and Registrations</h4>
                 
       
                  <div class="row col-lg-12">
                    
                      <div class="pt-3 table-responsive">
                    <table class="table table-bordered table-striped table-sm">
                      <thead class="thead-dark">
                            <th className="tabledata">S.No</th>
                            <th className="tabledata">Customer</th>
                            <th className="tabledata">Date Registered</th>
                            <th className="tabledata">Payment Amount</th>
                            <th className="tabledata">Payment Status</th>
                            <th className="tabledata">Action</th>
                      </thead>
                      <tbody>
                      {paymentlist.map((item, i) => {     

                            var renderpaidlbl='';
                            if(item.status=='paid')
                            renderpaidlbl='<span class="label label-success">Paid</span>';
                            else
                            renderpaidlbl='<span class="label label-danger">UnPaid</span>';

                       return <tr>
                            <td>{i + 1}</td>
                            <td>{item.firstname}</td>
                            <td>{item.created_date}</td>
                            <td>{item.amount_paid}</td>
                            <td dangerouslySetInnerHTML={{__html:renderpaidlbl}}></td>
                            <td><button class="btn btn-primary btn-sm" onClick={()=>this.handleClick(item.reg_id, item.camp_id)}>send mail</button></td>
                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>


                  </div>
                    
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default ViewPaymentCamp;


// WEBPACK FOOTER //
// ./src/components/bewise/bewiseViewPaymentCamp.jsx